/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resumes_Empty_SubtitleInputs */

const en_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your first resume to get started with applications.`)
};

const de_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstelle deinen ersten Lebenslauf, um mit Bewerbungen zu beginnen.`)
};

const fr_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crée ton premier CV pour commencer tes candidatures.`)
};

const es_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree su primer currículum para comenzar con las solicitudes.`)
};

const it_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il tuo primo curriculum per iniziare con le candidature.`)
};

const nl_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak je eerste CV om te beginnen met solliciteren.`)
};

const pl_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz swoje pierwsze CV, aby rozpocząć aplikowanie.`)
};

const fi_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo ensimmäinen ansioluettelosi aloittaaksesi hakemukset.`)
};

const da_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret dit første CV for at komme i gang med ansøgninger.`)
};

const sv_resumes_empty_subtitle = /** @type {(inputs: Resumes_Empty_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ditt första CV för att komma igång med ansökningar.`)
};

/**
* | output |
* | --- |
* | "Create your first resume to get started with applications." |
*
* @param {Resumes_Empty_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const resumes_empty_subtitle = /** @type {((inputs?: Resumes_Empty_SubtitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resumes_Empty_SubtitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_resumes_empty_subtitle(inputs)
	if (locale === "fr") return fr_resumes_empty_subtitle(inputs)
	if (locale === "es") return es_resumes_empty_subtitle(inputs)
	if (locale === "it") return it_resumes_empty_subtitle(inputs)
	if (locale === "nl") return nl_resumes_empty_subtitle(inputs)
	if (locale === "pl") return pl_resumes_empty_subtitle(inputs)
	if (locale === "fi") return fi_resumes_empty_subtitle(inputs)
	if (locale === "da") return da_resumes_empty_subtitle(inputs)
	if (locale === "sv") return sv_resumes_empty_subtitle(inputs)
	return en_resumes_empty_subtitle(inputs)
});